(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["levalmier-product-design"] && !Shopify.designMode) return;
  try {
    class LvProductDesign extends HTMLElement {
    busy = false;
    pending = 0;
    abort;
    observer;
    section;
    async connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.section = this.closest('.shopify-section');
      const { StandardEvents } = await import('@shopify/events');
      if (signal.aborted || !this.section) return;
      this.section.addEventListener(StandardEvents.cartLinesUpdate, event => {
        if (!event.target.closest?.('.product-details') || event.action !== 'add') return;
        this.pending++;
        this.busy = true;
        this.sync();
        Promise.resolve(event.promise).then(() => this.settled(), () => this.settled());
      }, { signal });
      this.section.addEventListener(StandardEvents.productSelect, event => {
        if (event.target.closest?.('product-card')) return;
        this.pending++;
        this.busy = true;
        this.sync();
        Promise.resolve(event.promise).then(() => this.settled(), () => this.settled());
      }, { signal });
      this.observer = new MutationObserver(() => this.sync());
      const details = this.section.querySelector('.product-details');
      if (details) this.observer.observe(details, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled','class','aria-busy'] });
      this.sync();
    }
    settled() { if (!this.isConnected) return; this.pending = Math.max(0, this.pending - 1); this.busy = this.pending > 0; this.sync(); }
    get button() { return this.section?.querySelector('.product-details product-form-component [ref="addToCartButton"]'); }
    purchase() {
      const button = this.button;
      if (!button || button.disabled || this.busy) return;
      const form = button.closest('form');
      if (form && !form.checkValidity()) {
        form.scrollIntoView({ block: 'center' });
        form.reportValidity();
        return;
      }
      button.click();
    }
    sync() {
      const button = this.button;
      if (!button) return;
      const sticky = this.section.querySelector('sticky-add-to-cart [ref="addToCartButton"]');
      if (sticky) sticky.disabled = button.disabled || this.busy;
      const id = this.section.querySelector('.product-details product-form-component')?.dataset.productId;
      document.querySelectorAll('lv-final-purchase').forEach(final => {
        if (final.dataset.productId !== id) return;
        final.syncFrom(this);
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  }
  class LvFinalPurchase extends HTMLElement {
    abort;
    visibilityObserver;
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelector('[data-lv-final-add]')?.addEventListener('click', () => this.source?.purchase(), { signal: this.abort.signal });
      customElements.whenDefined('lv-product-design').then(() => this.source?.sync());
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.source?.section?.toggleAttribute('data-lv-final-visible', entries[0].isIntersecting);
      });
      const button = this.querySelector('[data-lv-final-add]');
      if (button) this.visibilityObserver.observe(button);
    }
    get source() {
      return [...document.querySelectorAll('lv-product-design')].find(source => source.closest('.shopify-section')?.querySelector('.product-details product-form-component')?.dataset.productId === this.dataset.productId);
    }
    syncFrom(source) {
      const original = source.button;
      const button = this.querySelector('[data-lv-final-add]');
      if (!original || !button) return;
      button.disabled = original.disabled || source.busy;
      button.setAttribute('aria-busy', String(source.busy));
      const copy = original.cloneNode(true);
      copy.querySelectorAll('.svg-wrapper,.add-to-cart__added').forEach(item => item.remove());
      button.textContent = copy.textContent.trim();
      const price = source.section.querySelector('.product-details product-price [ref="priceContainer"]');
      if (price) this.querySelector('[data-lv-final-price]').innerHTML = price.innerHTML;
      const stickyVariant = source.section.querySelector('.sticky-add-to-cart__variant');
      this.querySelector('[data-lv-final-variant]').textContent = stickyVariant?.textContent.trim() || '';
      const error = source.section.querySelector('[ref="addToCartTextError"]:not(.hidden)');
      this.querySelector('[data-lv-final-error]').textContent = error?.textContent.trim() || '';
      const link = this.querySelector('.lv-final__options');
      const details = source.section.querySelector('.product-details');
      if (link && details) link.href = '#' + details.id;
    }
    disconnectedCallback() { this.abort?.abort(); this.visibilityObserver?.disconnect(); this.source?.section?.removeAttribute('data-lv-final-visible'); }
  }
  if (!customElements.get('lv-final-purchase')) customElements.define('lv-final-purchase', LvFinalPurchase);
  if (!customElements.get('lv-product-design')) customElements.define('lv-product-design', LvProductDesign);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lv-language-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.lvLanguageSelectorInit) return;
    window.lvLanguageSelectorInit = true;

    const COOKIE = 'lv_locale';

    /** Remember an explicit choice so automatic detection never overrides it. */
    const remember = (code) => {
      try {
        document.cookie = `${COOKIE}=${encodeURIComponent(code)}; path=/; max-age=31536000; SameSite=Lax`;
      } catch (e) {}
    };

    document.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-lv-lang-choice]');
      if (choice) {
        remember(choice.value);
        /* Return to the page the customer is actually on (the header can be re-rendered
           through the Section Rendering API, which would otherwise leak its own URL). */
        const returnTo = choice.form?.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search;
        if (choice.getAttribute('aria-current') === 'true') {
          event.preventDefault();
          const details = choice.closest('details[data-lv-lang]');
          if (details) {
            details.open = false;
            details.querySelector('summary')?.focus();
          }
        }
        return;
      }

      document.querySelectorAll('details[data-lv-lang][open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      const details = event.target.closest?.('details[data-lv-lang]');
      if (!details) return;

      const summary = details.querySelector('summary');
      const options = [...details.querySelectorAll('[data-lv-lang-choice]')];
      const index = options.indexOf(event.target);

      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        details.open = false;
        summary.focus();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!details.open) details.open = true;
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const next = index === -1 ? (step === 1 ? 0 : options.length - 1) : (index + step + options.length) % options.length;
        options[next]?.focus();
      }
    });

    document.addEventListener('focusout', (event) => {
      const details = event.target.closest?.('details[data-lv-lang]');
      if (details && details.open && event.relatedTarget && !details.contains(event.relatedTarget)) {
        details.open = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lv-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.lvSizeGuideInit) return;
    window.lvSizeGuideInit = true;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-lv-size-guide-open]');
      if (opener) {
        event.preventDefault();
        const dialog = opener.closest('[data-lv-size-guide]')?.querySelector('dialog');
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }

      const closer = event.target.closest('[data-lv-size-guide-close]');
      if (closer) {
        event.preventDefault();
        closer.closest('dialog')?.close();
        return;
      }

      /* Click on the backdrop (outside the panel) closes the guide. */
      if (event.target instanceof HTMLDialogElement && event.target.classList.contains('lv-size-guide__dialog')) {
        event.target.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
